export default "/kiban/_next/static/images/bottom_purple-aba5b316e8c335047337103308724666.png";